import { Fancybox } from "@fancyapps/ui";

class PopupManager {
  constructor() {
    this.cookieName = 'tilma_popup_closed';
    this.visitCountName = 'tilma_page_visits';
    this.settings = null;
    this.init();
    this.initHeaderButton();
  }

  init() {
    // Get popup settings from data attribute
    const popupElement = document.querySelector('[data-popup-settings]');
    if (!popupElement) return;

    this.settings = JSON.parse(popupElement.dataset.popupSettings);
    
    if (!this.settings.active) return;

    // Check if popup was recently closed
    if (this.getCookie(this.cookieName)) return;

    // Track page visits
    this.incrementPageVisits();
    const currentVisits = this.getPageVisits();

    // Check if we should show popup based on visit count
    if (currentVisits < this.settings.pageVisit) return;

    // Show popup after delay
    setTimeout(() => {
      this.showPopup(this.settings);
    }, this.settings.delay * 1000);
  }

  initHeaderButton() {
    const headerBtn = document.querySelector('.header__btn');
    if (headerBtn) {
      headerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.showPopup(this.settings || {});
      });
    }
  }

  showPopup(settings) {
    Fancybox.show([{
      src: '#modal',
      type: 'inline',
    }], {
      on: {
        close: () => {
          if (settings && settings.cookieDuration) {
            this.setPopupClosed(settings.cookieDuration);
          }
        }
      }
    });
  }

  incrementPageVisits() {
    const current = this.getPageVisits();
    this.setCookie(this.visitCountName, current + 1, 365); // Store for 1 year
  }

  getPageVisits() {
    const visits = this.getCookie(this.visitCountName);
    return visits ? parseInt(visits) : 0;
  }

  setPopupClosed(hours) {
    this.setCookie(this.cookieName, '1', hours / 24); // Convert hours to days
  }

  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}

// Initialize popup manager
new PopupManager();

export default PopupManager;
